import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { RootState } from '../store/rootReducer'

const PrivateRoute = ({ children, ...rest }: RouteProps): React.ReactElement => {
  const { authToken } = useSelector((state: RootState) => state.auth)

  return (
    <Route
      {...rest}
      render={({ location }) =>
        authToken ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}

export default PrivateRoute
